import { render, staticRenderFns } from "./Compose.PanelHeader.vue?vue&type=template&id=68b8c3d4&scoped=true&"
import script from "./Compose.PanelHeader.vue?vue&type=script&lang=js&"
export * from "./Compose.PanelHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b8c3d4",
  null
  
)

export default component.exports